<template>
    <el-dialog width="1200px"
               :visible.sync="DailogVisible"
               title="任务列表"
               :before-close="handleTaskClose"
               :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-card shadow="never" class="aui-card--fill">
            <div class="mod-plat__platinfouser}">
                <el-form :inline="true" :model="form" label-width="100px" >
                    <!--查询条件：任务发布编号、任务大类、合同编号、任务周期、预算金额、发布方-->
                    <el-form-item label="任务发布编号:">
                        <el-input v-model="form.taskCode" placeholder="请输入编号" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="任务大类:">
                        <el-select style="width: 100%;" v-model="form.taskType" placeholder="请选择任务大类" clearable filterable>
                            <el-option
                                    v-for="item in taskList"
                                    :key="item.ticketProId"
                                    :value="item.ticketProject"
                            ></el-option>
                        </el-select>
                    </el-form-item>

                    <!-- <el-form-item label="任务周期:">
                        <el-date-picker
                                style="width: 48%"
                                v-model="form.startDate"
                                placeholder="开始日期"
                                type="date"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                        ></el-date-picker>
                        <span style="width:4%;text-align: center;display: inline-block;">~</span>
                        <el-date-picker
                                style="width: 48%"
                                v-model="form.endDate"
                                placeholder="结束日期"
                                type="date"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                        ></el-date-picker>
                    </el-form-item> -->
                    <el-form-item v-if="userRights == 'OPERATE'"  label="发布方:" style="margin-top: 10px" >
                        <el-input  v-model="form.publishName" placeholder="请输入发布方" clearable></el-input>
                    </el-form-item>
                    <el-form-item style="margin-top: 10px;margin-left: 100px">
                        <el-button type="primary" @click="handleQuery()">查询</el-button>
                        <el-button type="primary" @click="handleReset()">重置</el-button>
                    </el-form-item>
                </el-form>
                <el-table :data="dataList"
                          @row-click="handleRadioChange"
                          highlight-current-row
                          border
                          style="width: 100%;margin-top: 20px;">
                    <el-table-column width="55">
                        <template slot-scope="scope">
                            <el-radio v-model="radio" :label="scope.row.id">
                                <span class="el-radio__label"></span>
                            </el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column label="序号" type="index" width="50" align="center">
                        <template slot-scope="scope">
                            <span>{{(pageObject.page - 1) * pageObject.limit + scope.$index + 1}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="taskCode"
                            label="任务发布编号"
                            header-align="center"
                            align="center"
                    ></el-table-column>
                    <el-table-column
                            prop="taskTypeName"
                            label="任务大类"
                            header-align="center"
                            align="center"
                    ></el-table-column>
                    <!-- <el-table-column
                            prop="requirePerson"
                            label="需求人数"
                            header-align="center"
                            align="center"
                    ></el-table-column> -->
                    <el-table-column
                            prop="contractCode"
                            label="合同编号"
                            header-align="center"
                            align="center"
                    ></el-table-column>
                    <!-- <el-table-column
                            prop="budget"
                            label="预算金额"
                            header-align="center"
                            align="center"
                    ></el-table-column>
                    <el-table-column
                            prop="startDate"
                            label="开始日期"
                            header-align="center"
                            align="center"
                    ></el-table-column>
                    <el-table-column
                            prop="endDate"
                            label="结束日期"
                            header-align="center"
                            align="center"
                    ></el-table-column> -->
                    <el-table-column
                            prop="publishName"
                            label="发布方"
                            header-align="center"
                            align="center"
                    ></el-table-column>
                </el-table>
                <el-pagination
                        background
                        :current-page="pageObject.page"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pageObject.limit"
                        :total="pageObject.total"
                        layout="total, sizes, prev, pager, next, jumper"
                        @size-change="handlePageSize"
                        @current-change="handleCurrentPage">
                </el-pagination>
            </div>
        </el-card>
        <template slot="footer">
            <el-button @click="handleTaskClose">取消</el-button>
            <el-button type="primary" @click="handleDetermine()">确认</el-button>
        </template>
    </el-dialog>
</template>
<script>
    import Cookies from 'js-cookie';
    import ArrayUtils from "../../../../../utils/ArrayUtils";
    export default {
        data() {
            return {
                taskList:[],
                form: {
                    taskCode: '',
                    publishName: '',
                    startDate: '',
                    endDate: '',
                    taskType:'',
                },
                radio: null, // 如果使用单选框，定义一个model值
                currentSelectItem: {}, //当前选中的值
                dataList:[],
                pageObject:{
                    page : 1,
                    limit : 10,
                    total : 0,
                },
                userRights:Cookies.get('admin_role'),
                rowID:"",                                  //选中的表格行Id
            }
        },
        props: ['DailogVisible','bodyId'],
        components: {},
        watch: {},
        computed: {
        },
        methods: {
//            任务大类请求
            getDropDownData(){
                this.$http.get('sys/plat/ticketPro/page?page=1&limit=1000&dictTypeId=1289513229072973825').then(({data:res})=>{
                    if(res.code == 0 ){
                        this.taskList = res.data.list;
                    }else{
                        this.$message.error(res.msg)
                    }
                })
            },
//            查询
            handleQuery(){
                this.$http.get(`sys/plat/task/pageForExport?page=${this.pageObject.page}&bodyId=${this.bodyId ? this.bodyId : ''}&limit=${this.pageObject.limit}&taskCode=${this.form.taskCode}&taskType=${this.form.taskType ? ArrayUtils.getItemBy(this.taskList,'ticketProject', this.form.taskType).ticketProject : ''}&startDate=${this.form.startDate}&endDate=${this.form.endDate}&publishName=${this.form.publishName}`).
                then(({ data: res }) => {
                    if(res.code == 0){
                        this.dataList = res.data.list;
                        this.pageObject.total = res.data.total;
                    }
                })
            },
//            重置
            handleReset(){
                this.form.taskCode = '';
                this.form.publishName = '';
                this.form.startDate = '';
                this.form.endDate = '';
                this.form.taskType = '';
                this.handleQuery();
            },

 //            表格单选框事件
            handleRadioChange(row) {
                this.rowID = row.id;
            },

//            分页
            handlePageSize(val){
                this.pageObject.page = 1
                this.pageObject.limit = val
                this.handleQuery()
            },
//            当前页数
            handleCurrentPage(val){
                this.pageObject.page = val
                this.handleQuery()
            },
            handleTaskClose(){
                this.$emit('handleTaskClose',false)
            },
//            执行下载模板
            handleDetermine(){
                if(this.rowID){
                    window.open(`${window.SITE_CONFIG['apiURL']}/sys/plat/deal/approval/exportTemplate?id=${this.rowID}&access_token=${Cookies.get('access_token')}&rowNum=500`)
                    this.$emit('handleTaskClose',false)
                }else{
                    this.$message.warning('请选择任务列表！')
                }
            }
        },
        created(){
            this.getDropDownData()
            this.handleQuery()
        }
    }
</script>
<style lang="scss">
</style>